import { getTranslation, errorTranslation } from './localization';
import { gaEvent, gaInViewEvent } from './analytics';
import { interpolate } from './interpolate';
import { markdownFilter, markdownNoWrapFilter } from './markdown';
import { roundStep } from './roundStep';
import priceFormatFilter from './priceFormat';
import currencyFilter from './currency';
import unixTimestampFilter from './formatUnixTimestamp';
import isoDateTimeFilter from './formatISODateTime';
import urlFormat from './urlFormat';
import sanitizeUrlFilter from './sanitizeURL';
import sanitizeAttrFilter from './sanitizeAttr';
import { contextUrl } from './urls';
import { writeReviewProfanityFilter } from './writeReviewProfanity';
import { _get, _getFromObj } from './safeGet';
import { include } from './include';
import imageQualityFilter from './imageQuality';
import { debug } from './debug';
import { items } from './items';
import { isFeatureEnabled } from './features';
import { escapeHtmlAttributes } from './escapeHtmlAttributes';
import { startswith } from './startswith';
import { keys, concatLists } from './objSupport';
import { appendParamString } from './appendParamString';
import { _min, _max } from './minMax';
import { getScene7ImagePath, getScene7VideoPath } from './mediaPathGetters';

module.exports = (env) => {
    // Add custom filters for nunjucks templates here:

    env.addGlobal('t', getTranslation);
    env.addGlobal('errorTranslation', errorTranslation);
    env.addGlobal('ga', gaEvent);
    env.addGlobal('ga_inview', gaInViewEvent);
    env.addGlobal('round_step', roundStep);
    env.addGlobal('contextUrl', contextUrl);
    env.addGlobal('_get', _get);
    env.addGlobal('_get_from_obj', _getFromObj);
    env.addGlobal('_include', include);
    env.addGlobal('items', items);
    env.addGlobal('isFeatureEnabled', isFeatureEnabled);
    env.addGlobal('_min', _min);
    env.addGlobal('_max', _max);
    env.addGlobal('getScene7ImagePath', getScene7ImagePath);
    env.addGlobal('getScene7VideoPath', getScene7VideoPath);
    env.addGlobal('concat_lists', concatLists);

    env.addFilter('debug', debug);
    env.addFilter('markdown', markdownFilter);
    env.addFilter('markdown_nowrap', markdownNoWrapFilter);
    env.addFilter('interpolate_values', interpolate);
    env.addFilter('priceFormat', priceFormatFilter);
    env.addFilter('currency', currencyFilter);
    env.addFilter('format_unix_timestamp', unixTimestampFilter);
    env.addFilter('format_iso_datetime', isoDateTimeFilter);
    env.addFilter('format_url', urlFormat);
    env.addFilter('sanitize_url', sanitizeUrlFilter);
    env.addFilter('sanitize_attr', sanitizeAttrFilter);
    env.addFilter('write_review_profanity', writeReviewProfanityFilter);
    env.addFilter('image_quality', imageQualityFilter);
    env.addFilter('escape_html_attributes', escapeHtmlAttributes);
    env.addFilter('startswith', startswith);
    env.addFilter('keys', keys);
    env.addFilter('append_param_string', appendParamString);
};
